import { Boxes } from "lucide-react";
import { MerchantFeedsManager } from "@/components/admin/MerchantFeeds";
import { MerchantSpotlightsManager } from "@/components/admin/MerchantSpotlights";

export default function AdminProductFeeds() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6" data-testid="admin-product-feeds">
      <div className="mb-1 flex items-center gap-2"><Boxes className="h-6 w-6 text-indigo-500" /><h1 className="text-2xl font-bold text-slate-900">Merchant Feeds</h1></div>
      <p className="mb-5 max-w-2xl text-sm text-slate-500">Paste an <b>approved</b> Cuelinks merchant datafeed URL (XML/JSON/CSV from your Cuelinks account manager). The app auto-imports product names, images and prices into Shop search results, and shows the last sync time and count per feed. Add as many merchants as you like. Prices come only from the feed — nothing is invented.</p>
      <MerchantFeedsManager testid="merchant-feeds" />
      <MerchantSpotlightsManager testid="merchant-spotlights" />
    </div>
  );
}
